import { Avatar, Button, Input, List, Select, Spin, Steps } from "antd";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import React, { useEffect, useState } from "react";
import { useMutation, useQuery } from "react-query";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import {
  approveCustomizedProductAndComment,
  getCustomizedProduct,
  rejectOrAcceptProtoCustomized,
} from "../../actions/order-actions/actions";
import { LoadingOutlined } from "@ant-design/icons";
import proto_illustration from "../../img/Prototype.svg";
import backArrow from "../../img/backArrow.png";
import { history } from "../..";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { CancelOrderDrawer } from "../../components/MyOrderConfirmation/CancelOrderDrawer";
import { MyNotif } from "../../components/NotifIcons/NotifIcons";
import "../../sass/MyOrderDetails.scss";
const { Step } = Steps;
const { Option } = Select;

export default function CustomizedOrderProgress() {
  const [isOwner, setIsOwner] = useState(false);
  const [quantity, setQuantity] = useState("");
  const [comment, setComment] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [notApproveIsVisible, setNotApproveIsVisible] = useState(false);
  const [approved, setApproved] = useState(false);
  const [current, setCurrent] = useState(0);

  const onChange = (value: number) => {
    console.log("onChange:", value);
    setCurrent(value);
  };
  const width = useBreakpoint();
  const { user } = useSelector((state: any) => state.auth);

  const { product_id } = useParams<{ product_id: string }>();

  const {
    data: product,
    isLoading: loadingProduct,
    isError,
    refetch,
  } = useQuery(
    `customized-product-${product_id}`,
    () => getCustomizedProduct(+product_id),
    {
      retry: false,
    }
  );

  console.log(product);

  useEffect(() => {
    if (product) {
      setIsOwner(product?.data.client.id === user.id);
    }
  }, [product]);

  const selectHandleChange = (e: any) => {
    setQuantity(e.target.value);
  };

  const showCancelDrawer = () => {
    setIsVisible(true);
  };

  const notApprovedOption = async (feedback: string = "") => {
    console.log(`Product ${product?.data.name} is not approved!!`);
    if (!feedback) {
      await approveOptAndComment({
        product_id,
        comment: `Not Approved: ${comment}`,
        status_id: 6,
      });
    } else {
      await approveOptAndComment({
        product_id,
        comment: `Not Approved: ${comment}`,
        status_id: 6,
        feedback,
      });
    }
    await rejectOrAcceptProto({
      response: "reject",
      id: +product_id,
      comment: `Not Approved: ${comment}`,
    });

    setIsVisible(false);
    setComment("");
    setNotApproveIsVisible(true);
    setTimeout(() => {
      setNotApproveIsVisible(false);
    }, 2000);
  };

  const {
    mutateAsync: approveOptAndComment,
    isLoading: approvingAndCommentLoading,
  } = useMutation(approveCustomizedProductAndComment);

  const {
    mutateAsync: rejectOrAcceptProto,
    isLoading: rejectOrAcceptProtoLoading,
  } = useMutation(rejectOrAcceptProtoCustomized, {
    onSuccess: (res) => {
      MyNotif(`Product ${res}ed and comments added successfully`, "success");
      refetch();
    },
  });

  const approveOption = async () => {
    console.log(
      `The product ${product?.data.name} is approved and comment is created and the quantity is ${quantity}!!`
    );
    setNotApproveIsVisible(true);
    setApproved(true);
    await approveOptAndComment({
      customized_product_id: product_id,
      comment: `Approved: ${comment}`,
      status_id: product?.data.status.id,
      qty: Number(quantity) ?? 0,
      size_qty: size_qty,
      delivery_date: delivery_date,
      product_id: product?.data.product_id,
    });
    await rejectOrAcceptProto({
      response: "accept",
      id: +product_id,
      comment: `Approved: ${comment}`,
    });
    setComment("");
    setTimeout(() => {
      setNotApproveIsVisible(false);
    }, 2000);
  };

  const approveProductAndSetQuantity = async () => {
    console.log(
      `Option ${product?.data.name} is approved and the quantity is ${quantity}!!`
    );
    await approveOption();
    await setQuantity("");
  };

  const [step, setSetp] = useState(product?.data?.status?.id);
  const [size_qty, setSizeQty] = useState("");
  const [delivery_date, setDeliviry_date] = useState("");

  if (loadingProduct) {
    return (
      <div
        style={{ width: "100%", height: "50vh" }}
        className="d-flex justify-content-center align-items-center"
      >
        <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="row pt-0">
        <div
          className="col-12 col-md-5 p-0 d-flex align-items-center"
          style={{ background: "#fcfdff", height: "100%" }}
        >
          <iframe
            src={
              product?.data.proto ? product?.data.proto : product?.data.link_360
            }
            style={{
              width: "100%",
              height: "calc(100vh - 227px)",
              border: "none",
            }}
          />
        </div>
        {isError ? (
          <div className="col-12 col-md-7 proto_container pl-3 text-center mt-5">
            <h1>Product Not Found</h1>
            <p style={{ maxWidth: "40rem", margin: "15px auto" }}>
              This product was cancelled, to see more details please visit the
              cancelled products list by clicking the button below
            </p>
            <Link to="/my-orders/customized-orders/cancelled">
              <Button className="approve_btn">Go to cancelled products</Button>
            </Link>
          </div>
        ) : (
          <div className="col-12 col-md-7 proto_container pl-3">
            <div className="proto_header m-4">
              <img
                src={backArrow}
                className="back_arrow_folder"
                alt="back arrow"
                onClick={() => history.back()}
              />
              <h1>My Orders</h1>
            </div>
            <div className="proto_breadcrumb_container my-4">
              <div className="d-flex align-items-center mb-2">
                <Avatar
                  src={
                    process.env.REACT_APP_STORAGE_URL +
                    product?.data.client.logo
                  }
                  size="default"
                />
                <p className="proto_breadcrumb mb-0 ml-2">{`${
                  product?.data.client.name
                } > ${product?.data.ref} > ${
                  (product?.data.code || "") + " " + product?.data.name
                }`}</p>
              </div>
              {product?.data.status.name !== "CANCELLED" && (
                <p className="proto_msg_welcome ">
                  Click in step to see more details
                </p>
              )}
            </div>

            <div className="steps_progress mt-4 d-flex justify-content-center">
              <Steps
                className={
                  product?.data.status.id === 6
                    ? "d-flex justify-content-center cancelled"
                    : ""
                }
                current={product?.data.status.id - 1}
                labelPlacement={"vertical"}
                direction={width.md ? "horizontal" : "vertical"}
              >
                {product?.data.status.id !== 6 && (
                  <>
                    <Step
                      title="PROTO"
                      onClick={() => setSetp(1)}
                      description={
                        product?.data.status.id >= 1 ? "View details" : ""
                      }
                      style={{
                        cursor: product?.data.status.id >= 1 ? "pointer" : "",
                      }}
                    />
                    <Step
                      title="PRE SMS"
                      onClick={() => setSetp(2)}
                      description={
                        product?.data.status.id >= 2 ? "View details" : ""
                      }
                      style={{
                        cursor: product?.data.status.id >= 2 ? "pointer" : "",
                      }}
                    />
                    <Step
                      title="SMS"
                      onClick={() => setSetp(3)}
                      description={
                        product?.data.status.id >= 3 ? "View details" : ""
                      }
                      style={{
                        cursor: product?.data.status.id >= 3 ? "pointer" : "",
                      }}
                    />
                    <Step
                      title="OK PROD"
                      onClick={() => setSetp(4)}
                      description={
                        product?.data.status.id >= 4 ? "View details" : ""
                      }
                      style={{
                        cursor: product?.data.status.id >= 4 ? "pointer" : "",
                      }}
                    />
                    <Step
                      title="PRODUCTION"
                      onClick={() => setSetp(5)}
                      description={
                        product?.data.status.id >= 5 ? "View details" : ""
                      }
                      style={{
                        cursor: product?.data.status.id >= 5 ? "pointer" : "",
                      }}
                    />
                  </>
                )}
              </Steps>
            </div>
            <div className="proto_footer">
              {product?.data.status.name !== "CANCELLED" && (
                <div className="mt-4">
                  <h1 className="my-3">
                    {(product?.data?.original_product?.code || "") +
                      " " +
                      product?.data?.original_product?.name}
                  </h1>
                  <p>{product?.data.description || ""}</p>
                  <>
                    <>
                      {product?.data.orders_status.map((el: any) => {
                        {
                          return (
                            <>
                              {el.status_id == step ? (
                                <>
                                  <table
                                    className="table_production "
                                    style={{
                                      marginBottom: "25px",
                                      borderRadius: "1em",
                                    }}
                                  >
                                    <tr className="border">
                                      <th className="border-right p-3">Qty</th>
                                      <td className="p-3">{el.qty || "-"}</td>
                                    </tr>
                                    <tr className="border">
                                      <th className="border-right p-3">
                                        size qty
                                      </th>
                                      <td className="p-3">
                                        {el.size_qty || "-"}
                                      </td>
                                    </tr>
                                    {/*           <tr className="border">
                                      <th className="border-right p-3">
                                        Date trims wearhouse
                                      </th>
                                      <td className="p-3">
                                        {el.date_trims_wearhouse
                                          ? moment(
                                              el.date_trims_wearhouse
                                            ).format("YYYY-MM-DD")
                                          : "-"}
                                      </td>
                                    </tr> */}
                                    {/*    <tr className="border">
                                      <th className="border-right p-3">
                                        Date fabric wearhouse
                                      </th>
                                      <td className="p-3">
                                        {el.date_fabric_wearhouse
                                          ? moment(
                                              el.date_fabric_wearhouse
                                            ).format("YYYY-MM-DD")
                                          : "-"}
                                      </td>
                                    </tr> */}
                                    <tr className="border">
                                      <th className="border-right p-3">
                                        Start production date
                                      </th>
                                      <td className="p-3">
                                        {el.start_production_date
                                          ? moment(
                                              el.start_production_date
                                            ).format("YYYY-MM-DD")
                                          : "-"}
                                      </td>
                                    </tr>
                                    <tr className="border">
                                      <th className="border-right p-3">
                                        Shipping date
                                      </th>
                                      <td className="p-3">
                                        {el.shipping_date
                                          ? moment(el.shipping_date).format(
                                              "YYYY-MM-DD"
                                            )
                                          : "-"}
                                      </td>
                                    </tr>
                                    <tr className="border">
                                      <th className="border-right p-3">
                                        Delivery date
                                      </th>
                                      <td className="p-3">
                                        {el.delivery_date
                                          ? moment(el.delivery_date).format(
                                              "YYYY-MM-DD"
                                            )
                                          : "-"}
                                      </td>
                                    </tr>
                                  </table>
                                </>
                              ) : (
                                <></>
                              )}
                            </>
                          );
                        }
                      })}
                    </>
                  </>
                  {product?.data.status.name !== "CANCELLED" && (
                    <>
                      {product?.data.orders_status.map((el: any) => {
                        return (
                          <>
                            {el.status_id == product?.data.status.id ? (
                              <>
                                <div>
                                  <SelectQuantity
                                    quantity={quantity}
                                    defaultQty={el.qty}
                                    selectHandleChange={selectHandleChange}
                                    disabled={
                                      product?.data.status.comments.length > 0
                                    }
                                  />
                                  <div className="final_order_select my-3">
                                    <label className="mr-3 mb-0">
                                      Size Quantity
                                    </label>
                                    <Input
                                      type="text"
                                      name="size_qty"
                                      value={size_qty || el.size_qty}
                                      onChange={(e) =>
                                        setSizeQty(e.target.value)
                                      }
                                      disabled={
                                        product?.data.status.comments.length > 0
                                      }
                                    ></Input>
                                  </div>
                                  <div className="final_order_select my-3">
                                    <label className="mr-3 mb-0">
                                      Delivery date
                                    </label>
                                    <Input
                                      type="date"
                                      name="delivery_date"
                                      value={
                                        delivery_date ||
                                        moment(el.delivery_date).format(
                                          "YYYY-MM-DD"
                                        )
                                      }
                                      onChange={(e) =>
                                        setDeliviry_date(e.target.value)
                                      }
                                      disabled={
                                        product?.data.status.comments.length > 0
                                      }
                                    ></Input>
                                  </div>
                                </div>
                              </>
                            ) : (
                              <></>
                            )}
                          </>
                        );
                      })}
                    </>
                  )}
                </div>
              )}

              {product?.data.status.name !== "CANCELLED" &&
                isOwner &&
                (product?.data.status.name === "SMS" ? (
                  <CommentsListAndForm
                    product={product?.data}
                    setComment={setComment}
                    comment={comment}
                    order={product?.data}
                  />
                ) : product?.data.status.name !== "PRODUCTION" ? (
                  <CommentsListAndForm
                    product={product?.data}
                    setComment={setComment}
                    comment={comment}
                    order={product?.data}
                  />
                ) : (
                  /*  <table className="table_production bg-white">
                    <tr className="border">
                      <th className="border-right p-3">Quantity</th>
                      <td className="p-3" style={{ width: 200 }}>
                        {product?.data.qty}
                      </td>
                    </tr>
                    <tr className="border">
                      <th className="border-right p-3">Start Production</th>
                      <td className="p-3" style={{ width: 200 }}>
                        {product?.data.shipping_date
                          ? moment(product?.data.shipping_date).format(
                              "DD/MM/YYYY"
                            )
                          : ""}
                      </td>
                    </tr>
                    <tr className="border">
                      <th className="border-right p-3">Shipping Date</th>
                      <td className="p-3" style={{ width: 200 }}>
                        {product?.data.shipping_date
                          ? moment(product?.data.shipping_date).format(
                              "DD/MM/YYYY"
                            )
                          : ""}
                      </td>
                    </tr>
                  </table> */
                  <></>
                ))}
              {
                isOwner &&
                  (product?.data.status.name !== "CANCELLED" ? (
                    <div className="proto_footer_btns my-4">
                      <Button
                        type="default"
                        className="cancel_btn"
                        onClick={() =>
                          product?.data.status.name === "PROTO"
                            ? showCancelDrawer()
                            : notApprovedOption()
                        }
                        disabled={product?.data.status.comments.length > 0}
                      >
                        {product?.data.status.name === "OK PROD"
                          ? "Not Approved"
                          : "Cancel"}
                      </Button>

                      <Button
                        type="default"
                        className="approve_btn"
                        loading={
                          approvingAndCommentLoading ||
                          rejectOrAcceptProtoLoading
                        }
                        onClick={() => {
                          if (product?.data.status.name === "SMS") {
                            approveProductAndSetQuantity();
                          } else {
                            approveOption();
                          }
                        }}
                        disabled={product?.data.status.comments.length > 0}
                      >
                        Approve
                      </Button>
                    </div>
                  ) : null)
                // <div className="proto_footer_btns my-4">
                //   <Button
                //     type="default"
                //     className="approve_btn"
                //     onClick={() => history.back()}
                //   >
                //     Go back to orders
                //   </Button>
                // </div>
              }
              {product?.data.status.id === 6 && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <h4
                    className="text-center"
                    style={{ color: "red", fontWeight: 400 }}
                  >
                    This product has been cancelled
                  </h4>
                  <div className="proto_footer_btns my-4">
                    <Button
                      type="default"
                      className="approve_btn"
                      onClick={() => history.back()}
                    >
                      Go back to orders
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      <CancelOrderDrawer
        isVisible={isVisible}
        setIsVisible={setIsVisible}
        article={product}
        notApprovedOption={notApprovedOption}
        // setAlerts={setAlerts}
        orderType={"customized_order"}
        productToCancel={product?.data.id}
        approvingAndCommentLoading={approvingAndCommentLoading}
        rejectOrAcceptProtoLoading={rejectOrAcceptProtoLoading}
      />
    </div>
  );
}

const SelectQuantity = ({
  quantity,
  selectHandleChange,
  defaultQty,
  disabled,
}: any) => {
  return (
    <div className="final_order_select my-3">
      <label className=" mb-0" style={{ marginRight: "50px" }}>
        Quantity
      </label>
      {/*     <Select
        defaultValue={quantity || defaultQty}
        style={{
          width: "100%",
        }}
        onChange={selectHandleChange}
        dropdownStyle={{
          borderRadius: 10,
          fontWeight: 600,
          fontSize: 20,
        }}
        suffixIcon={() => <FontAwesomeIcon icon={faCaretDown} />}
      >
        <Option value="">Select the number of pieces</Option>
        <Option value="1">1 Pc</Option>
        <Option value="2">2 Pcs</Option>
        <Option value="3">3 Pcs</Option>
        <Option value="4">4 Pcs</Option>
        <Option value="5">5 Pcs</Option>
      </Select> */}
      <Input
        defaultValue={quantity || defaultQty}
        style={{
          width: "100%",
        }}
        onChange={selectHandleChange}
        type="number"
        disabled={disabled}
      ></Input>
    </div>
  );
};

const CommentsListAndForm = ({ product, setComment, order, comment }: any) => {
  return (
    <>
      <div>
        <h1 style={{ fontSize: "1rem", fontWeight: 400 }}>Comments: </h1>
        <List
          itemLayout="horizontal"
          dataSource={product.status.comments}
          renderItem={(item: any) => (
            <List.Item>
              <List.Item.Meta
                avatar={
                  <Avatar
                    src={process.env.REACT_APP_STORAGE_URL + order.client.logo}
                  />
                }
                title={
                  <span>
                    {/* <span>{product.status.name}</span> */}
                    {item.comment.includes("NOT")
                      ? " NOT APPROVED BY "
                      : " APPROVED BY "}
                    {order.client.name}
                  </span>
                }
                description={item.comment}
              />
            </List.Item>
          )}
        />
      </div>
      <textarea
        rows={4}
        name="comment"
        value={comment}
        placeholder="Add a comment"
        className="comment_proto_order my-4"
        onChange={(e: any) => setComment(e.target.value)}
      ></textarea>
    </>
  );
};
